module.exports = __webpack_public_path__ + "static/media/img17.cdd88b9f.png";